import React, { useEffect } from 'react';
import Footer from '../components/Footer';

const Privacy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-earth-50 dark:bg-earth-900 pt-28 pb-0 px-4 lg:px-8 transition-colors duration-300">
            <div className="max-w-4xl mx-auto bg-white dark:bg-earth-800 rounded-3xl p-8 lg:p-12 shadow-xl border border-earth-100 dark:border-earth-700 mb-12">
                <h1 className="text-4xl font-bold text-earth-900 dark:text-earth-50 mb-8">Privacy Policy</h1>
                
                <section className="space-y-6 text-earth-700 dark:text-earth-200 leading-relaxed">
                    <p>
                        Last updated: May 21, 2026
                    </p>
                    
                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">1. Information We Collect</h2>
                    <p>
                        This portfolio website is designed to be as private as possible. We do not use tracking cookies or collect personal data from visitors who simply browse the site.
                    </p>
                    <p>
                        For administrative purposes, we may store a session token in your browser's local storage if you are an authorized administrator of this site.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">2. Use of Information</h2>
                    <p>
                        The data mentioned above is used solely for the technical operation of the site and to maintain security for administrative access.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">3. Third-Party Services</h2>
                    <p>
                        Images may be served from our private servers or trusted third-party content delivery networks. These services do not receive any personal information from you.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">4. Changes to This Policy</h2>
                    <p>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">5. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us through the contact section on the home page.
                    </p>
                </section>
            </div>
            <Footer />
        </main>
    );
};

export default Privacy;
